import { motion } from "framer-motion";
import Image from "next/image";

const list = [
    {
        title: "Mutual Success",
        p: "When your company grows, so do we. Our performance-based model means we're only invested in delivering real opportunities, not just activity, so your goals and ours stay aligned.",
    },
    {
        title: "Transparency",
        p: "Transparency runs both ways for us. Regular check-ins and open communication help us adapt campaigns to your needs, rather than a one-size-fits-all approach delivered and forgotten.",
    },
    {
        title: "Delivering on Our Promises",
        p: "You only pay for leads that have cleared our verification for fraud and intent, no hidden costs, no empty promises. If a lead doesn't fit, we make it right.",
    },
    {
        title: "Long-Term Relationships",
        p: "We're not chasing one-off campaigns. We listen, adapt, and refine your lead strategy over time, prioritizing lasting partnerships over short-term wins.",
    },
    {
        title: "Serving a Diverse Audience",
        p: "We reach U.S. audiences in the languages they speak, translating campaigns to connect with non-English-speaking residents alongside English-speaking ones.",
    },
];

export default function FirstSection() {
    return (
        <section className="lg:mt-28 mt-14 px-4 lg:px-0  lg:mb-10">
            <motion.div
                transition={{ duration: 1.5 }}
                initial={{ opacity: 0, y: 150 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
            >
                <h1 className="font-bold text-[#351C4F] 3xl:text-8xl 3xl:leading-[5.5rem] lg:text-6xl lg:leading-[4.5rem] text-4xl leading-10 text-center">
                    Lead Generation Built on Values
                </h1>
                <p className="lg:mt-7 mt-4 3xl:text-2xl 3xl:leading-10 lg:text-lg lg:leading-8 3xl:max-w-[1053px] max-w-[853px] mx-auto text-center font-light">
                    We grow when you grow. Several Brands' values, transparency,
                    mutual success, and long-term partnerships, are built around
                    performance-based lead generation.
                </p>
            </motion.div>

            <motion.section
                transition={{ duration: 1.5 }}
                initial={{ opacity: 0, y: 150 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className={`flex flex-col lg:flex-row   mt-10 lg:mt-16   3xl:gap-[200px] lg:gap-[150px] gap-[30px]`}
            >
                <div
                    className={` mx-auto lg:mx-0   order-1 lg:order-1 w-[300px]  h-[250px] md:w-[548px] md:min-w-[548px] md:h-[770px] 3xl:w-[648px] 3xl:min-w-[648px] 3xl:h-[870px] relative`}
                >
                    <Image
                        src={"/severalbrands/assets/images/ourValuesImg2.png"}
                        alt="img"
                        layout="fill"
                        objectFit="contain"
                    />
                </div>
                <div
                    className={` 3xl:max-w-[800px] max-w-[600px] mx-auto lg:mx-0 order-2 lg:order-2`}
                >
                    {list.map((el, index) => (
                        <div key={index} className="mt-8 first-of-type:mt-0">
                            <h2
                                className={`font-bold 3xl:text-4xl leading-[3rem] lg:text-2xl text-lg lg:leading-9 text-[#351C4F]  `}
                            >
                                {el.title}
                            </h2>
                            <p
                                key={index}
                                className={`mt-2 3xl:text-2xl 3xl:leading-10 lg:text-lg  text-base lg:leading-8  font-light`}
                            >
                                {el.p}
                            </p>
                        </div>
                    ))}
                </div>
            </motion.section>
        </section>
    );
}
